import React, { useEffect, useState } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { useSidebarState } from "contexts/sidebar";

import { Home, RightMinimalArrow } from "icons";

import { Typography } from "clearsense-ui/components";

import { HOME_LINKS } from "common/routes";

const SubHeader = ({ breadcrumbs, actionBlock, className }) => {
  const [currentItem, setCurrentItem] = useState();

  useEffect(() => {
    setCurrentItem(breadcrumbs[breadcrumbs.length - 1]);
  }, [breadcrumbs]);

  const { currentApp } = useSidebarState();

  return (
    <header className={classnames("cs-ui-sub-header", className)}>
      <div>
        <div
          className="cs-ui-sub-header__navigation"
          data-cy="bread-crumbs-links"
        >
          <Link
            to={HOME_LINKS[currentApp] ?? HOME_LINKS["others"]}
            className="cs-ui-sub-header__navigation__link"
          >
            <Typography
              style="h5"
              component="h5"
              className="cs-ui-sub-header__navigation__link__text"
            >
              <Home size={16} className="cs-ui-sub-header__navigation__icon" />
              <span className="ml-2">Home</span>
              <RightMinimalArrow
                size={16}
                className="cs-ui-sub-header__navigation__icon"
              />
            </Typography>
          </Link>
          {breadcrumbs
            .slice(0, breadcrumbs.length - 1)
            .map((breadcrumb, idx) => (
              <Link
                to={breadcrumb.link}
                key={idx}
                className="cs-ui-sub-header__navigation__link"
              >
                <Typography
                  style="h5"
                  component="h5"
                  className="cs-ui-sub-header__navigation__link__text"
                >
                  {breadcrumb.label}
                  {idx + 1 !== breadcrumbs.length && (
                    <RightMinimalArrow
                      size={16}
                      className="cs-ui-sub-header__navigation__icon"
                    />
                  )}
                </Typography>
              </Link>
            ))}
        </div>
        <Typography
          style="h3"
          type="semibold"
          className="cs-ui-sub-header__active text-content-darker"
          data-cy={currentItem?.dataCy}
        >
          {currentItem?.label}
        </Typography>
      </div>
      {actionBlock && <div>{actionBlock}</div>}
    </header>
  );
};

SubHeader.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, link: PropTypes.string })
  ).isRequired,
  actionBlock: PropTypes.node,
  className: PropTypes.string,
};

export default SubHeader;
